import React from 'react';
import Header from '../Header/Header.jsx';
import style from "./style.module.css"

const Gdpr = ({ toggleWebLanguage, webLanguage, toggleTheme, webTheme, webText, logMeOut }) => {

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Smooth scrolling
        });
    }, []);

    return(
      <>
        <Header
          webText={webText}
          toggleTheme={toggleTheme}
          toggleWebLanguage={toggleWebLanguage}
          webLanguage={webLanguage}
          webTheme={webTheme}
          logMeOut={logMeOut}
         />
        <div className={style.gdprBox}>
          <main className={style.gdprMain}>
              <header className={style.mainHeader}>
                <h2>Ochrana osobných údajov</h2>
              </header>
              <div className={style.ownerTitle}>
                  <p style={{gridRow:"span 6"}}>Prevádzkovateľ:</p>
                  <p>obchodné meno:</p>
                  <strong>BRAJO, s.r.o.</strong>
                  <p>právna forma:</p>
                  <p>spoločnosť s ručením obmedzeným</p>
                  <p>sídlo:</p>
                  <p>D.Michaelliho 15, 03601 Martin</p>
                  <p>IČO:</p>
                  <p>54987369</p>
                  <p>IČ DPH:</p>
                  <p>SK2121844274</p>
                  <p>zápis v registri:</p>
                  <p>Okresný súd Žilina, odd.SRO, vložka č.: 80745/L</p>
                  <p className={style.representative} style={{gridColumn:"span 2"}}>Kontaktné údaje zodpovednej osoby:</p>
                  <p className={style.representative}><strong>+421 905 664 628</strong>, <strong>+421 949 144 888</strong>, <strong>brajosro@gmail.com</strong></p>
              </div>
              <article className={style.lowerArticle}>
                Spoločnosť <strong>BRAJO, s.r.o.</strong> (ďalej len prevádzkovateľ) Vás v súlade s Nariadením Európskeho parlamentu a Rady (EÚ) 2016-679 o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto údajov (ďalej len nariadenie GDPR) a v zmysle Zákona č.18-2018 Z.z. o ochrane osobných údajov, účinného od 25. mája 2018 informuje, že poskytnuté údaje získané v súlade s Článkom 6, odsek1. Písm. b) nariadenia GDPR v rozsahu titul, meno, priezvisko, dátum narodenia, rodné číslo, ulica, mesto, PSČ, mailová adresa, telefonický kontakt, kópie dokladov a dokumentov, podpis budú spracovávané a uchované po dobu 10 rokov v informačnom systéme prevádzkovateľa, nakoľko uvedené osobné údaje sú nevyhnutné na uzatvorenie a plnenie zmluvných vzťahov, v ktorých zákazník vystupuje ako jedna zo zmluvných strán. Prevádzkovateľ prehlasuje, že poskytnuté údaje budú využívané výlučne na účel, pre ktoré boli získané a nebudú využívané na marketingové aktivity spoločnosti.
                <br />
                <br />
                Využitie Vašich osobných údajov na marketingové aktivity prevádzkovateľa za účelom ponuky tovarov a služieb, ich zdokonaľovania, za účelom prieskumu trhu, zisťovania spokojnosti zákazníkov a iné marketingové účely bude možné vždy len s Vašim dobrovoľným písomným súhlasom získaným v zmysle nariadenia GDPR. Udelený súhlas na spracovanie Vašich osobných údajov pre potreby marketingových aktivít je možné kedykoľvek odvolať.
                <br />
                <br />
                V záujme spravodlivého a transparentného spracúvania osobných údajov má dotknutá osoba nasledujúce práva: právo na prístup k osobným údajom, právo na opravu nepresných či nesprávnych údajov a doplnenie neúplných údajov, právo na výmaz údajov v prípade, ak zanikne účel spracúvania, alebo pokiaľ sú osobné údaje spracúvané nezákonne, právo na obmedzenie spracúvania osobných údajov, právo namietať proti spracúvaniu osobných údajov vrátane profilovania, právo na prenosnosť údajov, na základe ktorého môže dotknutá osoba získať osobné údaje, ktoré sa jej týkajú, v štruktúrovanom a strojovo čitateľnom formáte, a to buď pre seba, alebo pre iného prevádzkovateľa osobných údajov, právo podať sťažnosť u dozorného orgánu, ktorým je Úrad na ochranu osobných údajov Slovenskej republiky. Podrobnejšie informácie o právach dotknutej osoby sú prístupné na informačných tabuliach umiestnených v priestoroch prevádzkovateľa a výber zákonov, nariadení a smerníc si môžete pozrieť v prehľade nižšie.
                <br />
                <br />
                V prípade nejasností vo veci spracúvania osobných údajov sa dotknutá osoba môže obrátiť na zodpovednú osobu pre ochranu osobných údajov, a to prostredníctvom emailovej adresy <strong>brajosro@gmail.com</strong>
              </article>
              <div className={style.legalCodes}>
                  <h3>Výber zákonov, nariadení a smerníc, týkajúch sa ochrany fyzických osôb pri spracúvaní osobných údajov:</h3>
                  <div className={style.links}>
                      <a href='gdpr/data/zz18_2018.pdf'>Zbierka zákonov č.18/2018</a>
                      <a href='gdpr/data/zz122_2013.pdf'>Zbierka zákonov č.122/2013</a>
                      <a href='gdpr/data/zz136_2014.pdf'>Zbierka zákonov č.136/2014</a>
                      <a href='gdpr/data/zz84_2014.pdf'>Zbierka zákonov č.84/2014</a>
                      <a href='gdpr/data/smepofo_2016_680.pdf'>Smernica Európskeho parlamentu a Rady(EU) 2016/680</a>
                      <a href='gdpr/data/nareuofo_2016_679.pdf'>Nariadenie Európskeho parlamentu a Rady (EU) 2016/679</a>
                  </div>
              </div>
          </main>
        </div>
      </>
    );
};

export default Gdpr;